<!--
    画像アップロードのコンポーネント
    基本的な動作
    ・Storageへのアップロードとリサイズ
    ・アップロード先URLの返却
    親コンポーネントで必要な変更は次ブロックを参考
-->
<!--
●temlpate内の記述
    <profimg_upload @getImageUrl="getImageUrl"></profimg_upload>
-->
<!--
●methodsの追加
    //画像投稿URL取得
    getImageUrl(filename, ideaImage){
        //console.log("res-from-cp")
        if (ideaImage !=""){
          //縮小画像
          let filepath1 = "profimages/"+filename+"-sum.jpeg";
          const ref1 = firebase.storage().ref(filepath1);
          ref1.getDownloadURL().then((url)=>{
            this.profImageS = url
            //console.log("profimgurl",url);
          });
          //圧縮元画像
          let filepath2 = "profimages/"+filename+".jpeg";
          const ref2 = firebase.storage().ref(filepath2);
          ref2.getDownloadURL().then((url)=>{
            this.profImageO = url
            //console.log("profimgurl",url);
          });
        }else{
          this.profImageS = "";
          this.profImageO = "";
        }
      },
-->
<template>
    <div class="contents">
      <!-- <img class="camera" src="../assets/camera.svg" /> -->
      <v-col>
        <v-btn
          color="#707070"
          rounded
          width="150"
          v-show="!ideaImage"
        >
          <label class="input-item__label" >
            <v-icon color="#FFFFFF" size="19">mdi-camera </v-icon>
              画像を追加
            <input type="file" @change="onFileChange" />
          </label>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          color="#399942"
          rounded
          width="150"
          v-if="ideaImage"
          @click="images=true"
        >
          <label class="input-item__label" >
            挿入画像を確認
          </label>
        </v-btn>
      </v-col>
      <div v-if="ideaImage" class="preview-item">
        <v-avatar tile size="164">
          <img
            v-show="ideaImage"
            class="preview-item-file"
            :src="ideaImage"
            alt=""
          />
        </v-avatar>
        <div v-show="ideaImage" class="preview-item-btn" style="width:100;">
          <p class="preview-item-name">{{ img_name }}</p>
        </div>
        <div><a @click="removeimage">写真を削除</a></div>
      </div>

  
    <!--idea画像拡大時-->
    <v-dialog v-model="images"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #212121;">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large fab @click="images=false">
            <v-icon color="#E64550" x-large>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-img contain class="" max-height="70vh" :src="ideaImage" alt="プロフィール画像"></v-img>
      </v-card>
    </v-dialog>
    <v-dialog v-model="havetask" max-width="200px" style="background: white"
      >画像を確認中...</v-dialog
    >
  </div>
  </template>
   
  <script>
  import firebase from "firebase";
  import Compressor from "compressorjs";
  
  
  export default {
    name: "upImage",
    data() {
      return {
        tasks: 0,
        filename: "",
        ideaImage: "",
        img_name: "",
        imageflag: false,
        imgExe: "",
        storage: null,
        storageRef: null,
        images: false
      };
    },
    computed: {
      havetask() {
        if (this.tasks > 0) {
          return true;
        } else {
          return false;
        }
      },
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
    },
    created() {
      this.myConsole("upImage-created");
      this.storage = firebase.storage();
      this.storageRef = this.storage.ref();
    },
    mounted() {
      this.myConsole("upImage-mounted");
      //ランダムなファイル名をつける
      this.filename = Math.random().toString(36).slice(2);
      //this.$emit("getImageUrl", this.filename, this.imgExe, this.imageflag);
    },
    methods: {
      emit2pt() {
        this.$emit("getImageUrl", this.filename, this.ideaImage);
      },
      myConsole(msg) {//一括削除できるように
        //console.log(msg);
      },
      onFileChange(e) {
        this.tasks = 2;
        this.myConsole("onFileChange");
        const files = e.target.files || e.dataTransfer.files;
        this.createImage(files[0]);
        // 拡張子で分ける（※.が1つの想定です）
        const imgNameExe = files[0].name.split(".");
        // 拡張子から前
        let imgName = imgNameExe[0];
        // 拡張子から後ろ
        const imgExe = imgNameExe[1];
        this.imgExe = imgExe;
        //StorageにUP
        this.resizeImg(files[0]);
        this.originImg(files[0]);
        // 表示したいMaxのByte数（全角10文字、半角20文字）
        const maxBytes = 20;
        const imgNameBytes = encodeURIComponent(imgName).replace(
          /%../g,
          "x"
        ).length;
  
        // 画像ファイルとMax Byte数の比較
        if (imgNameBytes > maxBytes) {
          const zenkaku = imgNameBytes - imgName.length;
          if (zenkaku > 0) {
            imgName = imgName.slice(0, maxBytes / 2 - imgName.length) + "..";
          } else {
            imgName = imgName.slice(0, maxBytes - imgNameBytes) + "..";
          }
        }
  
        // 短くカットしたものと.と拡張子の文字列の連結
        imgName = imgName + "." + imgExe;
        this.img_name = imgName;
      },
      removeimage() {
        this.ideaImage = "";
        this.emit2pt();
      },
      // アップロードした画像を表示
      createImage(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.ideaImage = e.target.result;
        };
        reader.readAsDataURL(file);
        this.myConsole("createdImage");
      },
      //画像のアップロード
      upImg2Storage(file, filename, orgin) {
        var self = this;
  
        // Upload file and metadata to the object 'images/mountains.jpg'
        var uploadTask = this.storageRef
          .child("profimages/" + filename)
          .putString(file, "data_url", {
            customMetadata: {uid: self.uid}
          });
  
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(
          "state_changed", // or 'state_changed'
          (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.myConsole("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                this.myConsole("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                this.myConsole("Upload is running");
                break;
            }
          },
          (error) => {
            switch (error.code) {
              case "storage/unauthorized":
                break;
              case "storage/canceled":
                break;
              case "storage/unknown":
                break;
            }
          },
          () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              if (orgin) {
                self.emit2pt();
                self.tasks = self.tasks - 1;
              } else {
                self.ideaImage = downloadURL;
                self.emit2pt();
                self.tasks = self.tasks - 1;
              }
              return downloadURL;
            });
          }
        );
      },
      resizeImg(file) {
        let self = this;
        const payload = {
          quality: 0.9,
          maxWidth: 100,
          maxHeight: 100,
          mimeType: "image/jpeg",
          success(blob) {
            var reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result;
              if (result instanceof ArrayBuffer || result === null) return;
              self.upImg2Storage(result, self.filename + "-sum.jpeg", false);
            };
            reader.readAsDataURL(blob);
          },
          error(err) {
            //console.log(err.message);
          },
        };
        new Compressor(file, payload);
      },
      originImg(file) {
        let self = this;
        const payload = {
          quality: 0.8,
          mimeType: "image/jpeg",
          success(blob) {
            var reader = new FileReader();
            reader.onloadend = () => {
              const result = reader.result;
              if (result instanceof ArrayBuffer || result === null) return;
              self.upImg2Storage(result, self.filename + ".jpeg", true);
            };
            reader.readAsDataURL(blob);
          },
          error(err) {
            //console.log(err.message);
          },
        };
        new Compressor(file, payload);
      },
    },
  };
  </script>
  <style scoped>
.contents > .camera {
  cursor: pointer;
}
.input-item__label {
  cursor: pointer;
  color: #ffffff;
}
.input-item__label input[type="file"] {
  display: none;
}
.camera {
  width: 20px;
}
</style>